import styled, { css } from 'styled-components';

export const FlexedJC = styled.div`
  ${({ last }) => css`
    border-bottom: ${last ? 'none' : '1px solid #E0E6EB'};
    ${last && 'background-color: rgba(0, 94, 184, 0.04);'}
    ${last &&
    css`
      border-bottom-left-radius: 8px;
      border-bottom-right-radius: 8px;
    `}
  `}
  display: flex;
  justify-content: space-between;
  padding: 12px 24px;
`;
